import '@/styled-system/styles/recipes/property-map-module.css';
import { propertyMapModule } from '@/styled-system/recipes';

export const {
  container,
  stack,
  controls,
  toolbar,
  skeletonControl,
  skeletonCanvas,
  field,
  viewport,
  canvas,
  status,
  zoomControls,
  mapControls,
  gestureHint,
} = propertyMapModule();
